// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 353 ? "reactPlayerPreview" : chunkId) + "." + {"220":"e5f6f2cc","237":"1079023d","279":"b4de5249","321":"2bc38570","353":"ae1f4e0c","404":"8c2f36b5","453":"36ce2e48","512":"19b85fa2","537":"7fd24a84","850":"a42e70fc","875":"02b9f1ae"}[chunkId] + ".chunk.js";
};